import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { firestorePlugin } from 'vuefire'
import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.config.productionTip = false

Vue.use(firestorePlugin)

Vue.use(VueGtag, {
  config: { id: 'G-XVFL0MJVSV' }
}, router)

new Vue({
  router,
  store,
  beforeCreate () { this.$store.commit('initialiseStore') },
  render: h => h(App)
}).$mount('#app')
